export default __webpack_public_path__ + "static/media/f-logo.72ab3cb9.svg";